import type { AuditLogListApiData } from '@navio/nsdk';
import { filterUnitFor, useFilterUnits } from 'noddi-ui-web';
import { AUDIT_LOG_ACTION_OPTIONS } from 'noddi-util';
import { useAccountOptions } from '../Account/useAccountFilter';
import { useAuditLogContentTypeAppOptions, useAuditLogContentTypeModelOptions } from './useAuditLogContentTypeFilter';

type AuditLogFilterInput = Omit<
  NonNullable<AuditLogListApiData['query']>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search'
>;

const auditLogFilterUnit = filterUnitFor<AuditLogFilterInput>();

export const useAuditLogTableFilters = () => {
  const users = useAccountOptions();
  const contentTypeModels = useAuditLogContentTypeModelOptions();
  const contentTypeApps = useAuditLogContentTypeAppOptions();

  const filters = useFilterUnits([
    auditLogFilterUnit.toolbarDateRange({ from: 'timestampGte', to: 'timestampLte' }),
    auditLogFilterUnit.multiSelect('userIds', {
      title: 'Accounts',
      description: 'Filter by specific users',
      source: users
    }),
    auditLogFilterUnit.singleSelect('contentTypeModel', {
      title: 'Content type model',
      description: 'Filter by content type model',
      source: contentTypeModels
    }),
    auditLogFilterUnit.singleSelect('contentTypeApp', {
      title: 'Content type app',
      description: 'Filter by content type app label',
      source: contentTypeApps
    }),
    auditLogFilterUnit.singleSelect('action', { title: 'Action', options: AUDIT_LOG_ACTION_OPTIONS })
  ]);

  const { timestampGte, timestampLte } = filters.apiInput;

  const setDateRangeToToday = () => {
    const today = new Date();
    filters.dateRange?.onChange({ from: today, to: today });
  };

  return { filters, setDateRangeToToday, timestampGte, timestampLte };
};
